// Which Transport entries are finished, shared by the Transport page, the entry cards and the map (the backend
// equivalent is entry_is_finished / entry_is_complete in services/samsara_geofence.py).
//
// A branch STOCK TRANSFER keeps its "stock_transfer" status for its whole life (that is what makes it a transfer everywhere
// else: Transfer Details, the upcoming-transfers list, the branch pin ...). It is a stop the truck drives to like any
// delivery, so it is only finished once it has a `completed_at` — set automatically when the truck has visited and left it.
export const TERMINAL_ENTRY_STATUSES = ['complete', 'failed', 'cancelled', 'collection', 'service_issue'];

// Completed: a normal delivery marked complete, or a stock transfer that has been visited and left.
export const isEntryComplete = (entry) => !!entry && (
  entry.status === 'complete' || (entry.status === 'stock_transfer' && !!entry.completed_at)
);

// Finished: nothing more to do at this stop (complete, failed, cancelled, a collection, a service issue, or a visited transfer).
export const isEntryFinished = (entry) => {
  if (!entry) return false;
  const status = entry.status || '';
  if (status === 'stock_transfer') return !!entry.completed_at;
  return TERMINAL_ENTRY_STATUSES.includes(status);
};
